import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../mutation-types';
import NotificationAutoRepliesAPI from '../../api/notificationAutoReplies';

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

export const getters = {
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  getAutoReplies(_state) {
    return _state.records.sort((a, b) => b.id - a.id);
  },
  getAutoReplyById: _state => id => {
    return _state.records.find(record => record.id === Number(id));
  },
};

export const actions = {
  get: async function getAutoReplies({ commit }) {
    commit(types.SET_NOTIFICATION_AUTO_REPLY_UI_FLAG, { isFetching: true });
    try {
      const response = await NotificationAutoRepliesAPI.get();
      commit(types.SET_NOTIFICATION_AUTO_REPLIES, response.data);
    } catch (error) {
      // Ignore error
    } finally {
      commit(types.SET_NOTIFICATION_AUTO_REPLY_UI_FLAG, { isFetching: false });
    }
  },

  create: async function createAutoReply({ commit }, data) {
    commit(types.SET_NOTIFICATION_AUTO_REPLY_UI_FLAG, { isCreating: true });
    try {
      const response = await NotificationAutoRepliesAPI.create(data);
      commit(types.ADD_NOTIFICATION_AUTO_REPLY, response.data);
      return response.data;
    } finally {
      commit(types.SET_NOTIFICATION_AUTO_REPLY_UI_FLAG, { isCreating: false });
    }
  },

  update: async ({ commit }, { id, ...updateObj }) => {
    commit(types.SET_NOTIFICATION_AUTO_REPLY_UI_FLAG, { isUpdating: true });
    try {
      const response = await NotificationAutoRepliesAPI.update(id, updateObj);
      commit(types.EDIT_NOTIFICATION_AUTO_REPLY, response.data);
      return response.data;
    } finally {
      commit(types.SET_NOTIFICATION_AUTO_REPLY_UI_FLAG, { isUpdating: false });
    }
  },

  delete: async ({ commit }, id) => {
    commit(types.SET_NOTIFICATION_AUTO_REPLY_UI_FLAG, { isDeleting: true });
    try {
      await NotificationAutoRepliesAPI.delete(id);
      commit(types.DELETE_NOTIFICATION_AUTO_REPLY, id);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_NOTIFICATION_AUTO_REPLY_UI_FLAG, { isDeleting: false });
    }
  },

  toggle: async ({ commit }, id) => {
    commit(types.SET_NOTIFICATION_AUTO_REPLY_UI_FLAG, { isUpdating: true });
    try {
      const response = await NotificationAutoRepliesAPI.toggle(id);
      commit(types.EDIT_NOTIFICATION_AUTO_REPLY, response.data);
      return response.data;
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_NOTIFICATION_AUTO_REPLY_UI_FLAG, { isUpdating: false });
    }
  },
};

export const mutations = {
  [types.SET_NOTIFICATION_AUTO_REPLY_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },

  [types.ADD_NOTIFICATION_AUTO_REPLY]: MutationHelpers.create,
  [types.SET_NOTIFICATION_AUTO_REPLIES]: MutationHelpers.set,
  [types.EDIT_NOTIFICATION_AUTO_REPLY]: MutationHelpers.update,
  [types.DELETE_NOTIFICATION_AUTO_REPLY]: MutationHelpers.destroy,
};

export default {
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
};
